import { useGetAuthInfo } from '@doltech/core/lib/auth/withGlobalUserAuthInfo';
import { environment } from '@doltech/core/lib/environment/environment';
import { fromScreen } from '@doltech/core/lib/responsive/responsive.util';
import { Link } from '../../../../Link';
import * as React from 'react';
import styled from 'styled-components';
import { ResponsiveTypography } from '../../../../Typography/v3/ResponsiveTypography';
import { useUserAuthentication } from '../../../../Auth/hocs/withUserAuthentication';
import { ButtonSizableContent } from '../../../../Button/ButtonGeneral/ButtonSizableContent';
import { ButtonStyles } from '../../../../Button/ButtonStyles/ButtonStyles';
import { colorsV2 } from '../../../../colors-v2';

const Main = styled.div`
  background: ${colorsV2.paper5};
  padding: 32px 16px;

  .header-info {
    display: grid;
    grid-template-columns: minmax(0, 1fr);
    gap: 20px;

    margin: 0 auto;
  }

  ${fromScreen(768)} {
    padding: 100px 0;
    .header-info {
      width: 700px;
      gap: 28px;
      text-align: center;
    }
  }

  .underline-text {
    padding: 0 2px;
    background-image: linear-gradient(
      120deg,
      rgb(255, 153, 31, 0.35) 0%,
      rgb(255, 153, 31, 0.35) 100%
    );
    background-repeat: no-repeat;
    background-size: 100% 0.2em;
    background-position: 0 88%;
    transition: background-size 0.25s ease-;
  }
`;

const ActionWrapper = styled.div`
  display: flex;
  ${fromScreen(768)} {
    justify-content: center;
  }
`;

export const SectionHero = ({ title, description }) => {
  const { isLoggedIn } = useGetAuthInfo();
  const { openLoginModal } = useUserAuthentication();

  return (
    <Main className="section-hero">
      <div className="header-info">
        <ResponsiveTypography.Title
          className="title"
          color="black100"
          breakpoints={[0, 768]}
          variant={['bold/32-40', 'bold/48-57.6']}
          level={1}
          dangerouslySetInnerHTML={{ __html: title }}
        />

        <ResponsiveTypography.Paragraph
          color="black80"
          className="description"
          breakpoints={[0, 768]}
          variant={['regular/14-20', 'regular/20-28']}
        >
          {description}
        </ResponsiveTypography.Paragraph>
        <ActionWrapper>
          {isLoggedIn ? (
            <Link href={environment.REACT_APP_DOL_CORP_WEBSITE_HOST_NAME} target="_blank">
              <ButtonStyles
                buttonStyle="filled"
                color="primary"
                colorStyle="bold"
                content={<ButtonSizableContent text="Tìm hiểu khóa học" />}
              />
            </Link>
          ) : (
            <ButtonStyles
              buttonStyle="filled"
              color="primary"
              colorStyle="bold"
              onClick={openLoginModal}
              content={<ButtonSizableContent text="Đăng ký miễn phí ngay" />}
            />
          )}
        </ActionWrapper>
      </div>
    </Main>
  );
};
